// extracted by mini-css-extract-plugin
export default {"dragItem":"CreateDummy_dragItem__9+ZhM"};